class HybridUtils {
  constructor() {
    this.isWx = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1
    this.isApp = navigator.userAgent.toLowerCase().indexOf('zebra') > -1
    this.isNewShero = location.host.indexOf('selfsheroshop') > -1 || location.host.indexOf('youhushop') > -1
    this.isOffline = this.isOfflineFn()
    this.isIPhone = this.isIPhoneFn()
    this.isFullScreen = this.isFullScreenFn()
    this.env = this.getEnv()
    this.zebraVer = this.getZebraVersion()
    this.isSupportNavigationBar = this.isApp && this.zebraVer >= 273
    this.transparentIcon = 'https://img.gegejia.com/img/1e846b5617acc1bbfaa27474216c410a.png'
    this.blackLeftIcon = 'https://img.gegejia.com/img/14619146ff136114e548c02114d4354a.png'
    this.whiteNavigationBarRightIcon = 'https://img.gegejia.com/img/ba2c25937daa9efdca3233d567d2383f.png'
    this.whiteLeftIcon = 'https://img.gegejia.com/img/3f63e39b7aaa94cbf31c0031d9b3945c.png'
    this.redBarBg = 'https://img.gegejia.com/img/5f3037740eec65b85dff5195e7aacfdd.png'
    this.transparentBarBg = 'https://img.gegejia.com/img/85f170ccc788cde36a2f319ecae76bc9.png'
	  this.manageBgE = 'https://img.gegejia.com/img/2f0227ada0876e192c45f1c5f00c59e8.png'
	  this.manageBgSSV = 'https://img.gegejia.com/img/19971b1768b7fcb23b9d56e3acce26b2.png'
	  this.manageBgSSP = 'https://img.gegejia.com/img/d200b405a8080608564c120365618676.png'
	  this.manageBgSCO = 'https://img.gegejia.com/img/31b591b17f60f022e13864c684b826d5.png'
	  this.manageBgSEO = 'https://img.gegejia.com/img/8ceedab5c27b79903fb816896d4fce42.png'
    this.sheroBlackIcon = "https://cdn.gegejia.com/fe-ui/ssyh/return.png"
    this.sheroWhiteIcon = "https://img.gegejia.com/img/d030735990a91fa2debce0715a3bd000.png"
    this.whiteShareRightIcon = 'https://img.gegejia.com/img/3f64e4bc935f0e324472e79c7a88956e.png'
    this.whiteNavigationBarDefaultStyle = {
      // leftIcon: this.whiteLeftIcon,
      titleColor: '#222222',
      style: {
        headType: 0,
        // color: '#262b47'
      },
      statusbar: 1,
      androidBgColor:"#222222"
    }
	  this.isIphonex = () => {
		  if (typeof window !== 'undefined' && window) {
			  return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
		  }
		  return false;
	  };
  }

  setWhiteNavigationBar(options = {}) {
    if (this.isSupportNavigationBar) {
      window.ggj.setNavigationBar(Object.assign(this.whiteNavigationBarDefaultStyle, options))
    }
  }
  setBlueNavigationBar(options = {}) {
    if (this.isSupportNavigationBar) {
      window.ggj.setNavigationBar(Object.assign(this.whiteNavigationBarDefaultStyle, options))
    }
    if (this.isApp && this.zebraVer >= 276 && !this.isIPhone) {
      window.ggj.invoke('navigationBar', 'updateStatusBar', {
        statusbar: 1,
        // androidBgColor: '#262b47'
      })
    }
  }
  setNewBlueNavigationBar(options = {}) {
    if (this.isSupportNavigationBar) {
      window.ggj.setNavigationBar(Object.assign({
        leftIcon: this.sheroBlackIcon,
        titleColor: '#222222',
        style: {
          headType: 0,
          color: '#ffffff'
        },
        statusbar: 1
      }, options))
    }
    if (this.isApp && this.zebraVer >= 276 && !this.isIPhone) {
      window.ggj.invoke('navigationBar', 'updateStatusBar', {
        statusbar: 0,
        androidBgColor: '#222222'
      })
    }
  }
  getOfflineEnv () {
    let envType = 3
    const envMap = {
      '1': 'waptest',
      '2': 'wappreview',
      '3': 'wap',
      '4': 'wapdev'
    }
    let env = 'wap'
    if (this.isApp) {
      envType = getQueryString('env')
      env = envMap[envType] || 'wap'
    }
    return env
  }
  getEnv () {
    let env = this.isApp
      ? this.getOfflineEnv()
      : location.host.split('.')[0]
    if (~env.indexOf('localhost') || ~env.indexOf('local')) {
      env = 'waptest'
    }
    return env || 'wap'
  }
  isOfflineFn() {
    let tmp = window.location.href.indexOf('file:') === 0 || window.location.href.indexOf('hybrid') > 0
    return this.isApp && tmp
  }
  isIPhoneFn() {
    return ~navigator.userAgent.toLowerCase().indexOf('iphone')
  }
  isFullScreenFn() {
    return this.isIPhone && screen.height >= 812
  }
  getZebraVersion () {
    var ua = navigator.userAgent.toLowerCase()
    var result = ua.match(/zebra\/([\d\.]+)/)
    if (result && result[1]) {
      return result[1].replace(/\./g, '')
    } else {
      return 0
    }
  }
	getCookie (key) {
		var strCookie = document.cookie
		var arrCookie = strCookie.split('; ')

		for (var i = 0; i < arrCookie.length; i++) {
			var arr = arrCookie[i].split('=')
			if (arr[0] == key) return arr[1]
		}
		return ''
	}
}

export const utils = new HybridUtils()

export default {
  install (Vue, options) {
    Vue.prototype.$HybridUtils = utils

    Vue.prototype.$pushWindow = debounce(pushWindow, 500, true)
    Vue.prototype.$navigateBack = function goBack() {
      if (window.ggj.utils.isApp) {
        window.ggj.goBack()
      } else {
        window.history.back()
      }
    }

  }
}

function checkUrl(url) {
  const whiteColor = encodeURIComponent('262b47')
  const headColor = getQueryString('headColor')
  if (!headColor) {
    if (url.includes('?')) {
      url += `&headColor=${whiteColor}`
    } else {
      url += `?headColor=${whiteColor}`
    }
  }
  return url
}

function pushWindow(url, spm = 'noClickExporse') {
  const isApp = ~navigator.userAgent.indexOf('zebra')
  let params
  if (typeof url == 'object') {
    spm = url.spm || 'noClickExporse'
    url = url.url
  }
  if (isApp) {
    // url = checkUrl(url)
    params = {
      type: 'newwebview',
      url,
      spm
    }
  } else {
    params = {
      url,
      spm
    }
  }
  this.$goAnalyticUrl(params)
}

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = location.search.substr(1).match(reg);
  if (r != null) return unescape(decodeURI(r[2])); return null;
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce(func, wait, immediate) {
  var timeout, result;

  var later = function(context, args) {
    timeout = null;
    if (args) result = func.apply(context, args);
  };

  var debounced = restArguments(function(args) {
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(later, wait);
      if (callNow) result = func.apply(this, args);
    } else {
      timeout = delay(later, wait, this, args);
    }

    return result;
  });

  debounced.cancel = function() {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
}

// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
export function restArguments(func, startIndex) {
  startIndex = startIndex == null ? func.length - 1 : +startIndex;
  return function() {
    var length = Math.max(arguments.length - startIndex, 0),
        rest = Array(length),
        index = 0;
    for (; index < length; index++) {
      rest[index] = arguments[index + startIndex];
    }
    switch (startIndex) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, arguments[0], rest);
      case 2: return func.call(this, arguments[0], arguments[1], rest);
    }
    var args = Array(startIndex + 1);
    for (index = 0; index < startIndex; index++) {
      args[index] = arguments[index];
    }
    args[startIndex] = rest;
    return func.apply(this, args);
  };
}

// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
export var delay = restArguments(function(func, wait, args) {
  return setTimeout(function() {
    return func.apply(null, args);
  }, wait);
});
